import { createRef, useContext, useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import utilsUsers from "../_Utils/utilsUsers";
import { AddCircleOutline, AlignHorizontalLeftRounded, ArrowCircleRightSharp, ArrowCircleUp, ContactlessOutlined, HighlightOff, RemoveCircleOutline } from "@mui/icons-material";
import { MasterContext, OrderContext, UserContext } from "../ContextApi/context";
import { Checkbox } from "@material-ui/core";
import utilsOrders from "../_Utils/utilsOrders";
import PopUpMsg from "../DTechComp/PopUpMsg";

import Scroll from 'react-scroll';
import { Helmet } from "react-helmet";
import ConnUrls from "../Connections/ConnectURL";
import PopUpClearComp from "../DTechComp/PopUpClearComp";
import PopUpTheComp from "../DTechComp/PopUpTheComp";
import { Autocomplete, Button, TextField } from "@mui/material";
import utilsAdresses from "../_Utils/utilsAdresses";
var scroller = Scroll.scroller;

const AddAddress = (props) => {



    const [master, setMaster] = useContext(MasterContext);
    const [order, setOrder] = useContext(OrderContext);

    const [user, setUser, UserEffectFunction] = useContext(UserContext);
    const [userAdds, setUserAdds] = useState([]);

    const [allAds, setAllAds] = useState([]);
    const [thePopUp, setThePopUp] = useState("");

    const [theErrors, setTheErrors] = useState("");
    const [errorsTxts, setErrorsTxts] = useState("");

    const [street, setStreet] = useState("");
    const [num, setNum] = useState("");
    const [appartment, setAppartment] = useState("");
    const [ent, setEnt] = useState("");
    const [city, setCity] = useState("");
    const [flor, setFlor] = useState("");

    const [remarks, setRemarks] = useState("");
    const [delivPrice, setDelivPrice] = useState("");
    const [showAddNew, setShowAddNew] = useState(false);

    const [theSele, setTheSele] = useState("");
    const deliveryCitys = props.deliveryCitys && props.deliveryCitys.length != 0 ? props.deliveryCitys : [];
    const [streetsList, setStreetsList] = useState([]);
    const [selectedStreet, setSelectedStreet] = useState("");

    const cityRef = useRef(null);

    let theSelectdAdd = "";
    let popTiming = 0;


    const history = useHistory();



    useEffect(() => {
        cityRef.current?.focus();          // פוקוס אוטומטי על בחירת עיר
    }, []);

    //בדוק שכל התאים של הכתובת תקינים, 
    //או שיוצר הערות או שולח לפונקציה הוספת כתובת 
    const saveAddress = () => {



        let stopMe = false;
        let thEr = "";
        let errs = [];

        if (!city || city === "") {
            thEr = thEr !== "" ? thEr + ",city" : "city";
            errs.push('יש לבחור עיר מהרשימה')
        }
        if (selectedStreet.trim().length <= 1 || !streetsList.find(st => st === selectedStreet)) {
            thEr = thEr !== "" ? thEr + ",street" : "street";
            errs.push('יש לבחור רחוב מהרשימה')
        }
        if (num.trim().length <= 0) {
            thEr = thEr !== "" ? thEr + ",num" : "num";
            errs.push('יש לציין מספר דירה')
        }

        if (thEr != "") {
            setTheErrors(errs)
            setErrorsTxts(thEr)
        }
        else {
            addNewAddress();
            setErrorsTxts("")
            setTheErrors(errs)

        }
    }

    //הוספת כתובת בדאטה בייס
    const addNewAddress = async () => {
        let citybk = (city != null) ? city : "";
        if (user && user.firstName && user.firstName !== "") {
            let nItem = { street: selectedStreet, num, appartment, ent, flor, city: citybk, remarks, deliveryPrice: delivPrice };
            let addAdres = await utilsUsers.addNewAddress(user._id, nItem);
            theSelectdAdd = addAdres[addAdres.length - 1];
            setTheSele(theSelectdAdd);
            setUserAdds(addAdres)
            setUserAdds([addAdres])
            props.setAddrs(addAdres);
        }
        else {

            const newId = Date.now().toString();
            let nItem = { specialID: newId, street: selectedStreet, num, appartment, ent, flor, city: citybk, remarks, deliveryPrice: delivPrice };
            theSelectdAdd = nItem;
            setTheSele(nItem);
            setUserAdds([nItem])
            props.setAddrs([nItem]);
        }
        //מאפס את כל תיבות הטקסט לאחר הוספת הכתובת
        setStreet("");
        setNum("");
        setAppartment("");
        setEnt("");
        setCity("");
        setFlor("");
        setRemarks("");
        setTheErrors("");

        props.closeMe();

        //מעלים את הוספת כתובת
        setShowAddNew(false)
    }





    const setTheStreet = (val) => {
        setSelectedStreet(val);    // בלי תנאי
    };

    const setTheCity = (val) => {

        if (val !== "בחר") {
            let itm = deliveryCitys.find(ct => ct.cityName === val);

            setDelivPrice(itm.deliveryPrice);
            setTheSele(itm);
            getCityAdresses(itm);
            setCity(val)
        }
    }

    const getCityAdresses = async (city) => {
        let theLst = await utilsAdresses.getAddressesByCity(city.cityName);
        setStreetsList(theLst);
    }

    useEffect(() => {
        if (deliveryCitys.length === 1) {
            const [only] = deliveryCitys;          // { cityName, delivPrice, … }

            setCity(only.cityName);
            setDelivPrice(only.deliveryPrice);
            setTheSele(only);
            getCityAdresses(only);                 // מביא רשימת רחובות
        }
    }, [deliveryCitys]);



    return (
        <div id={props.addId} className="loginPage">
            <div className="firstMastSec">

                {props.noHead && (
                    <div className="sideClosBtn spinOnce" onClick={props.closeMe}>
                        <HighlightOff />
                    </div>
                )}

                <div className="bold huge centerText">כתובת למשלוח</div>
                <br />
                {(errorsTxts != "") &&
                    <div className={"errorLine"}>
                        {
                            errorsTxts.includes("city") ||
                            errorsTxts.includes("address") ||
                            errorsTxts.includes("num") ||
                            <p className={"big bold"}>{"התאים המסומנים הינם חובה"}</p>
                        }
                    </div>
                }

                {(theErrors != "") &&
                    <div className={"errorLine"}>
                        {
                            theErrors.map((itm, indx) => (
                                <p key={indx} className={"vsmall bold"}>- {itm}</p>

                            ))
                        }
                    </div>
                }

                <div className="addAddressBlock" id="newAddress">


                    {/* --- עיר --- */}
                    <div className="usrDet details">
                        <span className="spanCity">עיר: </span>
                        <select
                            ref={cityRef}
                            tabIndex={1}
                            className={`connInput ${errorsTxts.includes("city") ? "errorMe" : ""}`}
                            value={city}
                            onChange={(e) => setTheCity(e.target.value)}
                        >
                            <option value="בחר" className="customMenuItem">
                                בחר עיר מהרשימה
                            </option>
                            {deliveryCitys.map((c, i) => (
                                <option key={i} value={c.cityName} className="customMenuItem">
                                    {`${c.cityName} ( ₪${c.deliveryPrice} )`}
                                </option>
                            ))}
                        </select>
                    </div>

                    {/* --- רחוב --- */}
                    <div className="usrDet details">
                        <span className="spanCity">רחוב: </span>
                        <div className="connInputSpec">
                            <Autocomplete
                                freeSolo
                                disablePortal
                                disableClearable
                                options={streetsList}
                                value={selectedStreet}
                                className={`${errorsTxts.includes("street") ? "errorMe" : ""}`}
                                onChange={(_, v) => setTheStreet(v || "")}
                                inputValue={selectedStreet}
                                onInputChange={(_, v) => setTheStreet(v)}
                                ListboxProps={{ sx: { maxHeight: 400, direction: "rtl" } }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        placeholder="בחר רחוב או הקלד…"
                                        error={errorsTxts.includes("street")}
                                        disabled={!city}
                                        inputProps={{ ...params.inputProps, tabIndex: 2 }}
                                    />
                                )}

                            />
                        </div>
                    </div>

                    {/* --- בית / דירה / כניסה / קומה --- */}
                    <div className="usrDet">
                        <div className={`usrDetSmall details ${errorsTxts.includes("num") ? "errorMe" : ""}`}>
                            <input
                                tabIndex={3}
                                type="number"
                                className="connInput"
                                value={num}
                                placeholder="בית"
                                onChange={(e) => setNum(e.target.value)}
                            />
                        </div>
                        <div className={`usrDetSmall details ${errorsTxts.includes("apprtment") ? "errorMe" : ""}`}>
                            <input
                                tabIndex={4}
                                type="text"
                                className="connInput"
                                value={appartment}
                                placeholder="דירה"
                                onChange={(e) => setAppartment(e.target.value)}
                            />
                        </div>
                        <div className="usrDetSmall details">
                            <input
                                tabIndex={5}
                                type="text"
                                className="connInput"
                                value={ent}
                                placeholder="כניסה"
                                onChange={(e) => setEnt(e.target.value)}
                            />
                        </div>
                        <div className="usrDetSmall details">
                            <input
                                tabIndex={6}
                                type="text"
                                className="connInput"
                                value={flor}
                                placeholder="קומה"
                                onChange={(e) => setFlor(e.target.value)}
                            />
                        </div>
                    </div>

                    {/* --- הערות --- */}
                    <div className="usrDet details">
                        <textarea
                            tabIndex={7}
                            className="connInput"
                            value={remarks}
                            placeholder="הערות לשליח"
                            onChange={(e) => setRemarks(e.target.value)}
                        />
                    </div>

                    {/* --- כפתור שמירה --- */}
                    <div className="details fullWidth">
                        <div
                            tabIndex={8}
                            className="bold big ConDetailsBtn pointing"
                            onClick={saveAddress}
                        >
                            שמור כתובת
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );


}

export default AddAddress